// const apiUrl = settings.baseUrl + settings.apiPath;
const base = document.getElementsByTagName('base').item(0)?.href

class UrlService {
  get base() {
    return `${base}`
  }
  create(path: string) {
    return `${base}api/v1${path}`
  }
}

export default UrlService
export const url = new UrlService()
export const urlCreate = url.create
